import { useCallback, useState } from 'react';
import {
  EMPTY_TASK_DETAILS_TAB_ROUTE_STATE,
  type TaskDetailsTabRouteState,
} from '../task-route.utils';
import { TaskDetailsTab } from './TaskDetailsView.utils';

export const useTaskDetailsLocalNavigation = () => {
  const [fallbackTab, setFallbackTab] = useState(TaskDetailsTab.Details);
  const [tabRoutes, setTabRoutes] = useState<TaskDetailsTabRouteState>(
    EMPTY_TASK_DETAILS_TAB_ROUTE_STATE
  );

  const navigateToSubtasksList = useCallback(() => {
    setFallbackTab(TaskDetailsTab.Subtasks);
    setTabRoutes({
      ...EMPTY_TASK_DETAILS_TAB_ROUTE_STATE,
      isSubtasksActive: true,
    });
  }, []);

  const navigateToNewSubtask = useCallback(() => {
    setFallbackTab(TaskDetailsTab.Subtasks);
    setTabRoutes({
      ...EMPTY_TASK_DETAILS_TAB_ROUTE_STATE,
      isSubtasksActive: true,
      isAddingSubtask: true,
    });
  }, []);

  const navigateToEditSubtask = useCallback((subtaskId: string) => {
    setFallbackTab(TaskDetailsTab.Subtasks);
    setTabRoutes({
      ...EMPTY_TASK_DETAILS_TAB_ROUTE_STATE,
      isSubtasksActive: true,
      editingSubtaskId: subtaskId,
    });
  }, []);

  const navigateToCommentsList = useCallback(() => {
    setFallbackTab(TaskDetailsTab.Comments);
    setTabRoutes({
      ...EMPTY_TASK_DETAILS_TAB_ROUTE_STATE,
      isCommentsActive: true,
    });
  }, []);

  const navigateToNewComment = useCallback(() => {
    setFallbackTab(TaskDetailsTab.Comments);
    setTabRoutes({
      ...EMPTY_TASK_DETAILS_TAB_ROUTE_STATE,
      isCommentsActive: true,
      isAddingComment: true,
    });
  }, []);

  const handleTabChange = useCallback((tab: TaskDetailsTab) => {
    setFallbackTab(tab);
    setTabRoutes({
      ...EMPTY_TASK_DETAILS_TAB_ROUTE_STATE,
      isSubtasksActive: tab === TaskDetailsTab.Subtasks,
      isCommentsActive: tab === TaskDetailsTab.Comments,
      isActivityLogActive: tab === TaskDetailsTab.ActivityLog,
    });
  }, []);

  return {
    tabRoutes,
    fallbackTab,
    detailsViewKey: `${fallbackTab}-${tabRoutes.isAddingSubtask}-${tabRoutes.editingSubtaskId}-${tabRoutes.isAddingComment}`,
    navigateToSubtasksList,
    navigateToNewSubtask,
    navigateToEditSubtask,
    navigateToCommentsList,
    navigateToNewComment,
    handleTabChange,
  };
};
